import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../modules/Request/request';

export const getLogAnalyzer = createAsyncThunk(
  'getLogAnalyzer',
  async ({
    orgId, view, customEntityObjects,
  }, { rejectWithValue }) => {
    const response = await request('/log-analysis', {
      method: 'POST',
      params: [orgId],
      body: { customEntityObjects },
      query: { view },
    });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getLogAnalyzerDetails = createAsyncThunk(
  'getLogAnalyzerDetails',
  async ({
    orgId, view, customEntityObjects,
  }, { rejectWithValue }) => {
    const response = await request('/object-log-details', {
      method: 'POST',
      params: [orgId],
      body: { customEntityObjects },
      query: { view },
    });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
